import { createUseStyles } from 'react-jss'

import { lightGrey } from '../../styles/const/colors'
import { transitionShort } from '../../styles/const/common'

export default createUseStyles(theme => ({
  progressBar: {
    backgroundColor: lightGrey,
    position: 'relative',
    height: '10px',
    width: '100%',
    borderRadius: '2px',
    overflow: 'hidden'
  },
  progressLine: {
    backgroundColor: activeColor => activeColor || theme.brandPrimary,
    position: 'absolute',
    top: 0,
    left: 0,
    width: 0,
    height: '100%',
    borderRadius: '2px',
    transition: transitionShort
  }
}))
